import React, { CSSProperties } from 'react'
import SpinningIcon from '../../../components/Template/SpinningIcon'
import { IWithSize } from '../Calendar/Calendar'
import Button from './Button'
import FilterButton from './Button/FilterButton'
import Drawer from './Drawer'
import { Mixpanel } from '../../../utils/Mixpanel'

function FilterDrawer({
  activeFilters = 0,
  size = 1,
  style,
  isLoading = false,
  isFilterable = true,
}: IFilterDrawerProps & IFilterDrawerState & IWithSize) {
  const [isOpen, setIsOpen] = React.useState(false)

  function toggleDrawer() {
    if (!isOpen) {
      Mixpanel.track('Calendar Filter View', {})
    }
    setIsOpen(!isOpen)
  }

  if (isLoading || !isFilterable) {
    return (
      <FilterButton
        className={'FilterButton'}
        alignCenter={true}
        justifyStart={true}
        size={size}
        style={style}
      >
        {isLoading && <SpinningIcon style={{ margin: '0 auto' }} />}
      </FilterButton>
    )
  }

  return (
    <React.Fragment>
      <Button
        className={'FilterButton'}
        activeFilters={activeFilters}
        toggleDrawer={toggleDrawer}
        size={size}
        style={style}
      />
      {isOpen && (
        <Drawer
          activeFilters={activeFilters}
          toggleDrawer={toggleDrawer}
          size={size}
        />
      )}
    </React.Fragment>
  )
}

export default FilterDrawer

export interface IFilterDrawerProps {
  style?: CSSProperties
  isLoading?: boolean
  isFilterable?: boolean
}

export interface IFilterDrawerState {
  activeFilters?: number
}
